// This is borrowed from Elm. Quite a useful idea.
export function mapRemoteData(remote, mapFn) {
    if (remote.kind === "success") {
        return {
            kind: "success",
            data: mapFn(remote.data),
        };
    }
    return remote;
}
